import React from 'react';
import { get } from 'lodash';

import { useShowContext } from '../uibuilder/show/ShowReactContext';
import FullNameField from './FullNameField';

import styles from './UserLinkField.module.scss';

export interface Props {
  userIdSource: string;
  nameSource: string;
}

export default function UserLinkField(props: Props) {
  const { data } = useShowContext();

  const value = get(data, props.userIdSource) as number;

  const openUserPage = (event: any) => {
    (window as any).location = `/people/${value}`;
    event.stopPropagation();
  };

  if (value) {
    // eslint-disable-next-line max-len
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    return (
      <span onClick={openUserPage} className={styles.link}>
        <FullNameField source={props.nameSource} />
      </span>
    );
  } else {
    return null;
  }

}
